import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@mdi/font/css/materialdesignicons.min.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/400-italic.css';
import './styles/bootstrap/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueSimpleAlert from 'vue-simple-alert';
import i18n from './i18n';
import { setDocumentTitle } from './js/utils/i18n/document.js';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

// // Make BootstrapVue available throughout your project
// Vue.use(BootstrapVue)
// // Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin)

Vue.use(VueSimpleAlert);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.config.productionTip = false;
Vue.prototype.$hostName = 'https://apps.stratacache-apac.com/oag_wrapper/api';

setDocumentTitle(i18n.t('app.title'));

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
